import React, { useEffect } from 'react'

//components
import Navbar from '../components/Navbar/Navbar'
import Banner from '../components/Banner/LoanBanner'
import EmployeeInfo from '../components/CustomerInformation/EmployeeInfo'
import Footer from '../components/Footer/Footer'
  
const CustomerInfo = () => {
    useEffect(() => {
        window.scrollTo({top: 0, behavior: 'auto'})
    }, []);

    return (
        <>
            <Navbar /> 
            <Banner /> 
            <EmployeeInfo />
            <Footer />
        </>
    )
}

export default CustomerInfo
